// Vite glob — bundles every flag SVG at build time so they're referenced by
// hashed URL. The pattern is relative to this file, so the map stays valid
// wherever the design-system folder lives.
const flagModules = import.meta.glob<string>('./*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
});

/** Flag asset URLs keyed by lowercase country code (plus 'unknown'). */
export const flagUrls: Record<string, string> = Object.fromEntries(
  Object.entries(flagModules).map(([path, url]) => [path.slice(2, -4), url]),
);

// `unknown.svg` ships in this folder and is always bundled by the eager
// glob, so this is non-null at runtime. The assertion lets us avoid an
// `?? ''` fallback that would render `<img src="">` (browser navigates to
// the current document URL) if it ever fired.
export const UNKNOWN_FLAG_URL = flagUrls.unknown as string;

/** Resolve a country code (any case) to its flag URL, falling back to the
 *  unknown flag. */
export const getFlagUrl = (code: string | undefined): string =>
  (code ? flagUrls[code.toLowerCase()] : undefined) ?? UNKNOWN_FLAG_URL;
